namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmVyberovaSkupina extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmVyberovaSkupinaObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmVyberovaSkupinaObj());
            this.detailObj.createBase({
                contentName: "detailAdmVyberovaSkupina",
                contentCaption: "jres:33000432", //RC 33000432 : Výběrová skupina
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmVyberovaSkupina", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmVyberovaSkupinaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0}".format((this.data.nazev) ? this.data["nazev"] : "")
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.ixs_blk) ? this.data.ixs_blk : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (this.options.newRecord == false)
                data.ixs_blk = this.data.ixs_blk;
            (this.cnt.isl.AdmVyberovaSkupina.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVyberovaSkupina", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmVyberovaSkupina.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actRemoveFromDb*",
                {
                    type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVyberovaSkupinaObsah
                        }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actRemoveFromDb: {
                    caption: "jres:33000434", //RC 33000434 : Odstranit
                    icon: "gi-bin",
                    tooltip: this.savePermissionObj.reason,
                    enabled: this.savePermissionObj.permission && !this.options.newRecord,
                    run: (ev, ctx) => {
                        this.removeFromDb();
                    }
                },
                actOpenSeznamAdmVyberovaSkupinaObsah: {
                    caption: "jres:33000437",
                    icon: "fa-link",
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmVyberovaSkupinaObsah();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSeznamAdmVyberovaSkupinaObsah?.update({ enabled: !editMode })
            this.cnt.actions.actRemoveFromDb?.update({ enabled: !editMode })
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("")
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), { model: "model.ixs_fun=value.ixs_fun" })
            this.MakeSelectField("typ", Gordic.Prefabs.Select.admWflctyp(), {
                model: "model.typ=value.typ",
                serverFilters: {
                    typ: [0, 10]
                },
                change: (ev, obj) => {
                    var fieldSubj = this.cnt.findFields("typ_subj");
                    fieldSubj.gfield("option", "validators", [])
                    this.HideField("typ_subj");
                    if (obj.value) {
                        if (!Array.isArray(obj.value)) {
                            if (obj.value.typ == 10) {
                                this.ShowField("typ_subj")
                                fieldSubj.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                            }
                        }
                    }
                }
            })
            this.MakeSelectField("typ_subj", Gordic.Prefabs.Select.admWflctsu(), { model: "model.typ_subj=value.typ_subj" })
            this.MakeSection("")
            this.MakeField("dat_od", {
                validators: [new Gordic.Validators.Required({ stopping: true }) ]
            })
            this.MakeField("dat_do", {
                validators: [new Gordic.Validators.Required({ stopping: true }), this.getValidatorDatOdDo()]
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }

        private removeFromDb() {
            var data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaSaveDto = {};
            if (this.data.ixs_blk) {
                data.ixs_blk = this.data.ixs_blk;
                (this.cnt.isl.AdmVyberovaSkupina.delete({ data: data }).get() as any).done(() => {
                    this.cnt.notification("showToast", {
                        title: this.options.contentCaption,
                        content: "jres:33000433", //RC 33000433 : Odstranění výběrové skupiny proběhlo úspěšně.
                        state: "success",
                        icon: "fa-check-circle"
                    })
                    var grid = (this.options.gridRc as any).gridInstance.element;
                    var gridView: Gordic.Data.View = grid.ggrid("getView");
                    gridView.updateData({ ixs_blk: data.ixs_blk }, "delete");
                    this.cnt.close();
                })
            }
        }

        private openSeznamAdmVyberovaSkupinaObsah() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVyberovaSkupinaObsah"], {
                Id: "SeznamAdmVyberovaSkupinaObsah",
                ixs_blk: this.data.ixs_blk
            })
        }
    }
}